import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Label,
  Modal,
  Row,
  CardBody,
  ModalHeader,
  ModalBody,
  Spinner,
  Input,
  List,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import MetaTags from "react-meta-tags";
import API from "../../helpers/api_helper";
import * as Yup from "yup";
import toastr from "toastr";
import moment from "moment-jalaali";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { Formik, Field, Form, ErrorMessage } from "formik";
import BootstrapTable from "react-bootstrap-table-next";
import { Constants } from "helpers/constants";
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal";
import DatePicker from "react-modern-calendar-datepicker";
import Dropzone from "react-dropzone";

class ProductsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
      subLoading: false,
      modal: false,
      attrModal: false,
      formValue: {
        title: "",
        description: "",
        main_category: "",
      },
      isEdit: false,
      file: null,
      selectedUser: null,
      deleteModal: false,
      categories: [],
      imageFiles: [],
      planFiles: [],
      fileFiles: [],
      rows: [],
      rows1: [],
      attrListModal: false,
      pictureModal: false,
    };
  }
  componentDidMount() {
    this.didMount();
  }

  didMount = async () => {
    this.setState({ loading: true });
    try {
      const res = await API.products.list();
      console.log("RES IS : ", res);
      this.setState({
        loading: false,
        users: res.data,
      });

      try {
        const result = await API.category.list();
        if (result.status) {
          this.setState({ categories: result.data });
        } else {
          throw result;
        }
      } catch (error) {
        console.log("ERROR : ", error);
      }
    } catch (error) {
      console.log("ERROR CODE 3 : ", error);
    }
  };

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
      isEdit: false,
    }));
  };

  toggleAttr = () => {
    this.setState(prevState => ({
      attrModal: !prevState.attrModal,
    }));
  };

  handleSubmitAddForm = async values => {
    const { selectedUser, isEdit, imageFiles, planFiles, fileFiles } =
      this.state;
    this.setState({ subLoading: true });

    const formData = new FormData();

    formData.append("title", values.title);
    formData.append("description", values.description);
    formData.append("main_category", values.main_category);

    if (!!imageFiles.length)
      imageFiles.forEach(file => {
        formData.append("images[]", file, file.name);
      });

    if (!!planFiles.length)
      planFiles.forEach(file => {
        formData.append("images_plan[]", file, file.name);
      });
    if (!!fileFiles.length)
      fileFiles.forEach(file => {
        formData.append("file", file, file.name);
      });

    if (isEdit) {
      formData.append("product_id", selectedUser.id);
      try {
        const res = await API.products.edit(formData);
        if (res.status) {
          toastr.success(res.message, "موفق");
          this.setState({
            subLoading: false,
            modal: false,
            isEdit: false,
            selectedUser: null,
          });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        this.setState({ subLoading: false });
        console.log("ERROR CODE 5 : ", error);
      }
    } else {
      console.log("IS NEW FIRE");
      try {
        const res = await API.products.add(formData);
        console.log("RES IS : ", res);
        if (res.status) {
          toastr.success(res.message, "موفق");
          this.setState({ subLoading: false, modal: false });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        this.setState({ subLoading: false });
        console.log("ERROR CODE 4 : ", error);
      }
    }
  };

  handleUserClick = arg => {
    const { title, description, main_category } = arg;
    console.log("ARG : ", arg);

    this.setState({
      formValue: {
        title,
        description,
        main_category,
      },
      isEdit: true,
      selectedUser: arg,
    });

    setTimeout(() => this.setState({ isEdit: true }), 500);

    this.toggle();
  };

  handleShowAttrModal = arg => {
    this.setState({
      isEdit: true,
      selectedUser: arg,
    });

    this.toggleAttr();
  };

  handleShowDeleteAttrModal = arg => {
    this.setState({
      isEdit: true,
      selectedUser: arg,
      attrListModal: true,
    });
  };

  handleShowpicModal = user => {
    this.setState({
      isEdit: true,
      selectedUser: user,
      pictureModal: true,
    });
  };

  handleDeleteUser = async () => {
    const { selectedUser } = this.state;
    console.log("SELECTED : ", selectedUser);
    try {
      const { status } = await API.products.delete(selectedUser.id);
      if (status) {
        toastr.success("محصول با موفقیت حذف شد", "موفق");
        this.setState({ selectedUser: null, deleteModal: false });
        this.didMount();
      } else {
        throw status;
      }
    } catch (error) {
      console.log("ERROR CODE 128 : ", error);
    }
  };

  handleOpenDeleteModal = user => {
    this.setState({ deleteModal: true, selectedUser: user });
  };

  handleAcceptedPlanFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ planFiles: files });
  };

  handleAcceptedFileFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ fileFiles: files });
  };

  handleAcceptedImageFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ imageFiles: files });
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  handleAddRow = () => {
    const item = {
      enKey: "",
      enVal: "",
    };
    this.setState({
      rows: [...this.state.rows, item],
    });
  };

  handleAddRowNested = () => {
    const item1 = {
      faKey: "",
      faVal: "",
    };
    this.setState({
      rows1: [...this.state.rows1, item1],
    });
  };

  handleRemoveRow = (e, idx) => {
    if (idx === "01") {
      document.getElementById("addr" + idx).style.display = "block";
    } else if (typeof idx != "undefined") {
      document.getElementById("addr" + idx).remove();
    }
  };

  handleRemoveRowNested = (e, idx) => {
    document.getElementById("nested" + idx).remove();
  };

  handleAddSpecific = async () => {
    let faKeyQuery = document.querySelectorAll(".faKey");
    let faValQuery = document.querySelectorAll(".faVal");
    let enKeyQuery = document.querySelectorAll(".enKey");
    let enValQuery = document.querySelectorAll(".enVal");

    console.log("enKeyQuery : ", enKeyQuery);

    if (!!this.state.selectedUser) {
      const formData = new FormData();
      formData.append("product_id", this.state.selectedUser.id);

      faKeyQuery.forEach((val, i) => {
        if (!!val.value && !!faValQuery[i].value) {
          formData.append(`fa[${i}][key]`, val.value);
          formData.append(`fa[${i}][value]`, faValQuery[i].value);
        }
      });

      enKeyQuery.forEach((val, i) => {
        if (!!val.value && !!enValQuery[i].value) {
          formData.append(`en[${i}][key]`, val.value);
          formData.append(`en[${i}][value]`, enValQuery[i].value);
        }
      });

      try {
        const res = await API.products.addSpecific(formData);
        console.log("RES IS : ", res);
        if (res.status) {
          toastr.success(res.message, "موفق");
          this.setState({
            attrModal: false,
          });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        console.log("ERRROR : ", error);
      }
    }
  };

  handleDeleteAttr = async item => {
    this.setState({ subLoading: true });

    try {
      const res = await API.products.deleteSpecific(item.id);
      if (res.status) {
        toastr.success(res.message, "موفق");
      } else {
        throw res;
      }
    } catch (error) {
      console.log("ERRI : ", error);
    }
    this.didMount();
    this.setState({ subLoading: false, attrListModal: false });
  };

  handleDeletePic = async item => {
    this.setState({ subLoading: true });

    try {
      const res = await API.products.deletePic(item.id);
      if (res.status) {
        toastr.success(res.message, "موفق");
      } else {
        throw res;
      }
    } catch (error) {
      console.log("ERRI : ", error);
    }
    this.didMount();
    this.setState({ subLoading: false, pictureModal: false });
  };

  render() {
    const { SearchBar } = Search;
    const {
      users,
      loading,
      modal,
      attrModal,
      isEdit,
      subLoading,
      formValue,
      deleteModal,
      categories,
      attrListModal,
      pictureModal,
    } = this.state;

    const pageOptions = {
      sizePerPage: 10,
      totalSize: users.length, // replace later with size(users),
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];

    const selectRow = {
      mode: "checkbox",
    };

    const columns = [
      {
        text: "id",
        dataField: "id",
        sort: true,
        hidden: true,
        formatter: (cellContent, user) => <>{user.id}</>,
      },
      {
        text: "عنوان",
        dataField: "title",
        sort: true,
      },
      {
        dataField: "description",
        text: "توضیحات",
        sort: true,
        formatter: val => (
          <p style={{ whiteSpace: "break-spaces", textAlign: "justify" }}>
            {val}
          </p>
        ),
      },
      {
        dataField: "main_category",
        text: "دسته بندی",
        sort: true,
      },
      {
        dataField: "menu",
        isDummyField: true,
        editable: false,
        text: "Action",
        formatter: (cellContent, user) => (
          <div className="d-flex gap-3">
            <Link className="text-warning" to="#">
              <i
                className="mdi mdi-image-area font-size-18"
                id="edittooltip"
                onClick={() => this.handleShowpicModal(user)}
              ></i>
            </Link>
            <Link className="text-danger" to="#">
              <i
                className="mdi mdi-playlist-minus font-size-18"
                id="edittooltip"
                onClick={() => this.handleShowDeleteAttrModal(user)}
              ></i>
            </Link>
            <Link className="text-info" to="#">
              <i
                className="mdi mdi-playlist-plus font-size-18"
                id="edittooltip"
                onClick={() => this.handleShowAttrModal(user)}
              ></i>
            </Link>
            <Link className="text-success" to="#">
              <i
                className="mdi mdi-pencil font-size-18"
                id="edittooltip"
                onClick={() => this.handleUserClick(user)}
              ></i>
            </Link>
            <Link className="text-danger" to="#">
              <i
                className="bx bx-trash font-size-18 mt-1"
                id="edittooltip"
                onClick={() => this.handleOpenDeleteModal(user)}
              ></i>
            </Link>
          </div>
        ),
      },
    ];

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteUser}
          onCloseClick={() =>
            this.setState({ deleteModal: false, selectedUser: null })
          }
        />
        <div className="page-content">
          <MetaTags>
            <title>خانه من | مدیریت محصولات</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="خانه من" breadcrumbItem="مدیریت محصولات" />
          </Container>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <Spinner size="lg" />
                  ) : (
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columns}
                      data={users}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columns}
                          data={users}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                        placeholder="جستجو"
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      color="primary"
                                      className="font-16 btn-block btn btn-primary bg-gold"
                                      onClick={this.toggle}
                                    >
                                      <i className="mdi mdi-plus-circle-outline me-1" />
                                      ایجاد محصول جدید
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      selectRow={selectRow}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={this.node}
                                    />

                                    <Modal
                                      isOpen={modal}
                                      size="lg"
                                      onClosed={() =>
                                        this.setState({
                                          formValue: {
                                            title: "",
                                            description: "",
                                            main_category: "",
                                          },
                                        })
                                      }
                                    >
                                      <ModalHeader
                                        toggle={this.toggle}
                                        tag="h4"
                                      >
                                        {!!isEdit
                                          ? "ویرایش محصول"
                                          : "اضافه کردن محصول"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={formValue}
                                          validationSchema={Yup.object().shape({
                                            title:
                                              Yup.string().required("اجباری"),
                                            description:
                                              Yup.string().required("اجباری"),
                                            main_category: Yup.string(),
                                          })}
                                          onSubmit={this.handleSubmitAddForm}
                                        >
                                          {({ errors, status, touched }) => (
                                            <Form>
                                              <Row>
                                                <Col xs={12} md={6}>
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      عنوان
                                                    </Label>
                                                    <Field
                                                      name="title"
                                                      type="text"
                                                      className={
                                                        "form-control" +
                                                        (errors.title &&
                                                        touched.title
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="title"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={6}>
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      دسته بندی
                                                    </Label>
                                                    <Field
                                                      name="main_category"
                                                      as="select"
                                                      className={
                                                        "form-control" +
                                                        (errors.main_category &&
                                                        touched.main_category
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    >
                                                      <option></option>
                                                      {!!categories.length &&
                                                        categories.map(item => (
                                                          <option
                                                            value={item.name}
                                                            key={item.id}
                                                          >
                                                            {item.name}
                                                          </option>
                                                        ))}
                                                    </Field>
                                                  </div>
                                                </Col>
                                                <Col xs={12}>
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      توضیحات
                                                    </Label>
                                                    <Field
                                                      name="description"
                                                      type="text"
                                                      as="textarea"
                                                      rows={3}
                                                      className={
                                                        "form-control" +
                                                        (errors.description &&
                                                        touched.description
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="description"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                </Col>

                                                <Col xs={12} md={6}>
                                                  <div className="mb-3">
                                                    <Dropzone
                                                      onDrop={acceptedFiles =>
                                                        this.handleAcceptedImageFiles(
                                                          acceptedFiles
                                                        )
                                                      }
                                                      multiple={true}
                                                    >
                                                      {({
                                                        getRootProps,
                                                        getInputProps,
                                                      }) => (
                                                        <div className="dropzone">
                                                          <div
                                                            className="dz-message needsclick"
                                                            {...getRootProps()}
                                                          >
                                                            <input
                                                              {...getInputProps()}
                                                            />
                                                            <div className="mb-3">
                                                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                            </div>
                                                            <h4>
                                                              برای انتخاب عکس
                                                              های اصلی کلیک کنید
                                                              یا بکشید
                                                            </h4>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </Dropzone>
                                                    <div
                                                      className="dropzone-previews mt-3"
                                                      id="file-previews"
                                                    >
                                                      {this.state.imageFiles.map(
                                                        (f, i) => {
                                                          return (
                                                            <Card
                                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                              key={i + "-file"}
                                                            >
                                                              <div className="p-2">
                                                                <Row className="align-items-center">
                                                                  <Col className="col-auto">
                                                                    <img
                                                                      data-dz-thumbnail=""
                                                                      height="80"
                                                                      className="avatar-sm rounded bg-light"
                                                                      alt={
                                                                        f.name
                                                                      }
                                                                      src={
                                                                        f.preview
                                                                      }
                                                                    />
                                                                  </Col>
                                                                  <Col>
                                                                    <Link
                                                                      to="#"
                                                                      className="text-muted font-weight-bold"
                                                                    >
                                                                      {f.name}
                                                                    </Link>
                                                                    <p className="mb-0">
                                                                      <strong>
                                                                        {
                                                                          f.formattedSize
                                                                        }
                                                                      </strong>
                                                                    </p>
                                                                  </Col>
                                                                </Row>
                                                              </div>
                                                            </Card>
                                                          );
                                                        }
                                                      )}
                                                    </div>
                                                  </div>
                                                </Col>

                                                <Col xs={12} md={6}>
                                                  <Dropzone
                                                    onDrop={acceptedFiles =>
                                                      this.handleAcceptedPlanFiles(
                                                        acceptedFiles
                                                      )
                                                    }
                                                    multiple={true}
                                                  >
                                                    {({
                                                      getRootProps,
                                                      getInputProps,
                                                    }) => (
                                                      <div className="dropzone">
                                                        <div
                                                          className="dz-message needsclick"
                                                          {...getRootProps()}
                                                        >
                                                          <input
                                                            {...getInputProps()}
                                                          />
                                                          <div className="mb-3">
                                                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                          </div>
                                                          <h4>
                                                            برای انتخاب عکس های
                                                            نقشه کلیک کنید یا
                                                            بکشید
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </Dropzone>
                                                  <div
                                                    className="dropzone-previews mt-3"
                                                    id="file-previews"
                                                  >
                                                    {this.state.planFiles.map(
                                                      (f, i) => {
                                                        return (
                                                          <Card
                                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                            key={i + "-file"}
                                                          >
                                                            <div className="p-2">
                                                              <Row className="align-items-center">
                                                                <Col className="col-auto">
                                                                  <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={f.name}
                                                                    src={
                                                                      f.preview
                                                                    }
                                                                  />
                                                                </Col>
                                                                <Col>
                                                                  <Link
                                                                    to="#"
                                                                    className="text-muted font-weight-bold"
                                                                  >
                                                                    {f.name}
                                                                  </Link>
                                                                  <p className="mb-0">
                                                                    <strong>
                                                                      {
                                                                        f.formattedSize
                                                                      }
                                                                    </strong>
                                                                  </p>
                                                                </Col>
                                                              </Row>
                                                            </div>
                                                          </Card>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </Col>

                                                <Col xs={12}>
                                                  <Dropzone
                                                    onDrop={acceptedFiles =>
                                                      this.handleAcceptedFileFiles(
                                                        acceptedFiles
                                                      )
                                                    }
                                                    multiple={false}
                                                  >
                                                    {({
                                                      getRootProps,
                                                      getInputProps,
                                                    }) => (
                                                      <div className="dropzone">
                                                        <div
                                                          className="dz-message needsclick"
                                                          {...getRootProps()}
                                                        >
                                                          <input
                                                            {...getInputProps()}
                                                          />
                                                          <div className="mb-3">
                                                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                          </div>
                                                          <h4>
                                                            انتخاب یک فایل برای
                                                            این محصول
                                                          </h4>
                                                        </div>
                                                      </div>
                                                    )}
                                                  </Dropzone>
                                                  <div
                                                    className="dropzone-previews mt-3"
                                                    id="file-previews"
                                                  >
                                                    {this.state.fileFiles.map(
                                                      (f, i) => {
                                                        return (
                                                          <Card
                                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                            key={i + "-file"}
                                                          >
                                                            <div className="p-2">
                                                              <Row className="align-items-center">
                                                                <Col className="col-auto">
                                                                  <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={f.name}
                                                                    src={
                                                                      f.preview
                                                                    }
                                                                  />
                                                                </Col>
                                                                <Col>
                                                                  <Link
                                                                    to="#"
                                                                    className="text-muted font-weight-bold"
                                                                  >
                                                                    {f.name}
                                                                  </Link>
                                                                  <p className="mb-0">
                                                                    <strong>
                                                                      {
                                                                        f.formattedSize
                                                                      }
                                                                    </strong>
                                                                  </p>
                                                                </Col>
                                                              </Row>
                                                            </div>
                                                          </Card>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  {subLoading ? (
                                                    <div className="text-end">
                                                      <button
                                                        type="button"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        <i className="bx bx-loader bx-spin font-size-16 align-middle" />{" "}
                                                        Loading
                                                      </button>
                                                    </div>
                                                  ) : (
                                                    <div className="text-end">
                                                      <button
                                                        type="submit"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        Save
                                                      </button>
                                                    </div>
                                                  )}
                                                </Col>
                                              </Row>
                                            </Form>
                                          )}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>

        <Modal
          isOpen={attrModal}
          onClosed={() =>
            this.setState({
              attrFormValue: {
                title: "",
                description: "",
                main_category: "",
              },
            })
          }
        >
          <ModalHeader toggle={this.toggleAttr} tag="h4">
            {!!isEdit ? "ویرایش محصول" : "اضافه کردن محصول"}
          </ModalHeader>
          <ModalBody>
            <Formik
              enableReinitialize={true}
              initialValues={formValue}
              validationSchema={Yup.object().shape({
                title: Yup.string().required("اجباری"),
                description: Yup.string().required("اجباری"),
                main_category: Yup.string(),
              })}
              onSubmit={this.handleSubmitAddForm}
            >
              {({ errors, status, touched }) => (
                <Form>
                  <Row>
                    <Col xs={12}>
                      <div className="inner-repeater mb-4">
                        <Label>مشخصات فارسی :</Label>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr id="addrMain" key="">
                              <td>
                                <Row className="inner mb-3 ">
                                  <Col md="5" className="col-8">
                                    <Input
                                      type="text"
                                      className="inner form-control faKey"
                                      placeholder={"کلید واژه" + 1}
                                    />
                                  </Col>
                                  <Col md="5" className="col-8">
                                    <Input
                                      type="text"
                                      className="inner form-control faVal"
                                      placeholder={"آیتم" + 1}
                                    />
                                  </Col>
                                  <Col md="2" className="col-4">
                                    <Button
                                      disabled
                                      color="danger"
                                      className="btn-block inner"
                                      style={{ width: "100%" }}
                                    >
                                      {" "}
                                      حذف
                                    </Button>
                                  </Col>
                                </Row>
                              </td>
                            </tr>

                            {this.state.rows1.map((item1, idx) => (
                              <tr id={"nested" + idx} key={idx}>
                                <td>
                                  <Row className="inner mb-3">
                                    <Col md="5" className="col-8">
                                      <Input
                                        type="text"
                                        className="inner form-control faKey"
                                        placeholder={"کلید واژه" + (idx + 2)}
                                      />
                                    </Col>
                                    <Col md="5" className="col-8">
                                      <Input
                                        type="text"
                                        className="inner form-control faVal"
                                        placeholder={"آیتم" + (idx + 2)}
                                      />
                                    </Col>
                                    <Col md="2" className="col-4">
                                      <Button
                                        onClick={e =>
                                          this.handleRemoveRowNested(e, idx)
                                        }
                                        color="danger"
                                        className="btn-block inner"
                                        style={{ width: "100%" }}
                                      >
                                        حذف
                                      </Button>
                                    </Col>
                                  </Row>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <Button onClick={this.handleAddRowNested} color="info">
                          اضافه کردن ویژگی
                        </Button>
                      </div>
                    </Col>

                    <hr />
                    <Col xs={12}>
                      <div
                        className="inner-repeater mb-4"
                        style={{
                          direction: "ltr",
                          textAlign: "left",
                        }}
                      >
                        <Label
                          style={{
                            textAlign: "left",
                            width: "100%",
                          }}
                        >
                          English specifications :
                        </Label>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr id="addrMain" key="">
                              <td>
                                <Row className="inner mb-3 ">
                                  <Col md="5" className="col-8">
                                    <Input
                                      type="text"
                                      className="inner form-control enKey"
                                      placeholder={"key" + 1}
                                    />
                                  </Col>
                                  <Col md="5" className="col-8">
                                    <Input
                                      type="text"
                                      className="inner form-control enVal"
                                      placeholder={"value" + 1}
                                    />
                                  </Col>
                                  <Col md="2" className="col-4">
                                    <Button
                                      disabled
                                      color="danger"
                                      className="btn-block inner"
                                      style={{ width: "100%" }}
                                    >
                                      {" "}
                                      Delete
                                    </Button>
                                  </Col>
                                </Row>
                              </td>
                            </tr>

                            {this.state.rows.map((item1, idx) => (
                              <tr id={"nested" + idx} key={idx}>
                                <td>
                                  <Row className="inner mb-3">
                                    <Col md="5" className="col-8">
                                      <Input
                                        type="text"
                                        className="inner form-control enKey"
                                        placeholder={"key" + (idx + 2)}
                                      />
                                    </Col>
                                    <Col md="5" className="col-8">
                                      <Input
                                        type="text"
                                        className="inner form-control enVal"
                                        placeholder={"value" + (idx + 2)}
                                      />
                                    </Col>
                                    <Col md="2" className="col-4">
                                      <Button
                                        onClick={e =>
                                          this.handleRemoveRowNested(e, idx)
                                        }
                                        color="danger"
                                        className="btn-block inner"
                                        style={{ width: "100%" }}
                                      >
                                        Delete
                                      </Button>
                                    </Col>
                                  </Row>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <Button onClick={this.handleAddRow} color="info">
                          Add new Property
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      {subLoading ? (
                        <div className="text-end">
                          <button
                            className="btn btn-success save-user bg-gold"
                            style={{
                              minWidth: "100px",
                            }}
                          >
                            <i className="bx bx-loader bx-spin font-size-16 align-middle" />{" "}
                            Loading
                          </button>
                        </div>
                      ) : (
                        <div className="text-end">
                          <button
                            className="btn btn-success save-user bg-gold"
                            style={{
                              minWidth: "100px",
                            }}
                            onClick={this.handleAddSpecific}
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={attrListModal}
          onClosed={() =>
            this.setState({ attrListModal: false, selectedUser: null })
          }
        >
          <ModalHeader
            toggle={() => this.setState({ attrListModal: !attrListModal })}
            tag="h4"
          >
            حذف ویژگی های محصول
          </ModalHeader>
          <ModalBody>
            {!!this.state.selectedUser &&
            !!this.state.selectedUser.detail_product.length ? (
              this.state.selectedUser.detail_product.map(item => (
                <div
                  key={item.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: "1px solid",
                  }}
                >
                  <span>{item.key}</span>
                  <span>{item.value}</span>
                  <Button
                    color="danger"
                    onClick={() => this.handleDeleteAttr(item)}
                  >
                    حذف
                  </Button>
                </div>
              ))
            ) : (
              <div
                style={{
                  width: "100%",
                  minHeight: "150px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span>ویژگی برای این محصول ثبت نشده است</span>
              </div>
            )}
          </ModalBody>
        </Modal>

        <Modal
          isOpen={pictureModal}
          onClosed={() =>
            this.setState({ pictureModal: false, selectedUser: null })
          }
        >
          <ModalHeader
            toggle={() => this.setState({ pictureModal: !pictureModal })}
            tag="h4"
          >
            تصاویر محصول
          </ModalHeader>
          <ModalBody>
            <div
              style={{
                display: "grid",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                gridTemplateColumns: "1fr 1fr 1fr",
                gridGap: "15px",
              }}
            >
              {!!this.state.selectedUser &&
              !!this.state.selectedUser.images.length ? (
                this.state.selectedUser.images.map(item => (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={Constants.imageUrl + item.images}
                      alt=""
                      style={{ width: "100%" }}
                    />
                    <Button
                      color="danger"
                      block
                      onClick={() => this.handleDeletePic(item)}
                    >
                      حذف
                    </Button>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    width: "100%",
                    minHeight: "150px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span>تصویری برای این محصول ثبت نشده است</span>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ProductsPage;
